<template>
  <div style="background: #fefbfb">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      background-color="#6b6969"
    />
    <TopNavbar />
    <section class="container-fluid job-fair-text" style="padding-top: 7rem">
      <div class="row">
        <div class="col-md-12 text-center">
          <h2 class="font-weight-bold heading-title">
            Modules Available on Portal
          </h2>
          <div
            class="divider bg-orange"
            style="width: 158px; height: 10px; border-radius: 0; margin: 0 auto"
          ></div>
        </div>
      </div>
    </section>

    <!-- Job section -->
    <!-- v-for="(m,i) in modules" :key="i" -->
    <div class="container-fluid job-fair-text">
      <div class="row pt-5 pb-5">
        <div
          class="col-md-5 offset-md-1 pb-5"
          :class="[i % 2 == 0 ? 'border-right' : '',(i % 2 === 0 && i ===(modules.length-2)) ? 'last-border' :'']"
          v-for="(m, i) in modules"
          :key="i"
        >
          <div class="row">
            <div class="col-md-10">
              <ul class="list-group">
                <li class="list-group-item bg-green pl-5">
                  <h3 class="">{{m.title}}</h3>
                  <div
                    class="cursor-pointer"
                    @click="instructorDetails(m.course_instructor_name,m.course_instructor_description,m.course_instructor_img)"
                  >
                    {{m.course_instructor_name}}
                    <i class="fa fa-chevron-right" />
                  </div>
                </li>

                <li class="list-group-item" v-for="(item, j) in m.CoachSchoolModuleTopics" :key="item.id">
                  <div class="accordion" :id="'accordionExample' + item.id">
                    <div
                      class="mb-2 accordion-button"
                      data-toggle="collapse"
                      :data-target="'#collapse' + item.id"
                      aria-controls="collapseFive"
                    >
                      {{item.title}}
                    </div>

                    <div
                      :id="'collapse' + item.id"
                      :class="['collapse ml-4', j == 0 ? 'show' : '']"
                      aria-labelledby="headingOne"
                      :data-parent="'#accordionExample' + item.id"
                    >
                      <div class="mb-2 cursor-pointer" v-for="(v, j) in item.CoachSchoolModuleVideos" :key="'i'+j">
                        <i class="material-icons"> play_circle_outline </i>
                        <span style="vertical-align: super">
                          {{v.title}}</span
                        >
                      </div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item text-center">
                  <button class="btn btn-orange btn-curve btn-sm">
                    Enroll Now
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid job-fair-text">
      <div class="row">
        <div class="col-md-8 offset-md-2 text-center">
          <p>
            *Apply for our <span class="text-orange">scholarships</span> and
            receive between 50% to 100% discount. Women and persons with
            disability stand a chance of receiving 70% discount on the training.
            Our scholarships cover the cost of training, training materials,
            examination and certification costs.
          </p>
        </div>
      </div>
    </div>

    <div class="join-coach">
      <div class="container-fluid job-fair-text">
        <div class="row pt-5 pb-5">
          <div class="col-md-12 text-center">
            <h2 class="heading-title">
              JOIN THE STARTUP COACH <br />
              SCHOOL COMMUNITY
            </h2>
            <button class="btn btn-orange pl-3 pr-3">Become a Coach</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="instructorModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              style="
                background: #e5e5e5;
                padding: 5px 10px;
                color: #0000008a;
                opacity: 1;
                border-radius: 50px;
              "
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mt-5">
            <div
              class="border"
              style="border-radius: 10px; padding: 20px; margin-bottom: 4rem"
            >
              <div class="row" style="color: #b0b0b0">
                <div class="col-md-5">
                  <img :src="instructor_img?instructor_img:'@/assets/instructor.png'" class="img-fluid" alt="" />
                  <div class="mt-3">COURSE INSTRUCTOR</div>
                  <h5 class="mt-0">{{instructor_name}}</h5>
                </div>
                <div class="col-md-7">
                  <p>
                    {{instructor_description}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottomFooter />
  </div>
</template>

<script>
/* eslint-disable */

// import Footer from "../components/Footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import moment from "moment";
import $ from "jquery";

export default {
  name: "Modules",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
      modules: [],
      instructor_name:'',
      instructor_img:'',
      instructor_description:'',
    };
  },
  components: {
    TopNavbar: () => import("@/components/TalentNav"),
    Loading,
    bottomFooter: () => import("@/components/Footer"),
  },
  methods: {
    instructorDetails(name,desc,img){
      this.instructor_name =name;
      this.instructor_description =desc;
      this.instructor_img =img;
      window.$("#instructorModal").modal("show");

    },
    getModules() {
      this.isLoading = true;
      axios
        .get(`${process.env.VUE_APP_COMPANY_URL}/modules`, this.data)
        .then((res) => {
          this.modules = res.data.data;
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    document.title = "About || Start Up Coach School";
    this.getModules();
  },
};
</script>

<style src="../../../public/assets/css/general-front-css.css" scoped />

<style scoped>
.last-border::after {
  font-family: "Material Icons", serif;
  content: "\e5cf";
  position: absolute;
  bottom: -10px;
  right: -13px;
  background: #e5e5e5;
  padding: 0 5px;
  border-radius: 5px;
}
.fa-chevron-right {
  font-size: 13px;
}
@media only screen and (max-width: 768px) {
  .last-border::after, .border-right{
    display: none;
  }
  
}

.list-group-item:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.list-group-item {
  background-color: #f2feff;
}
.bg-green {
  background-color: #059ca6 !important;
}

.join-coach {
  background-image: url("../../assets/patterns.png");
  background-size: cover;
}
.accordion-button {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  /* padding: 1rem 1.25rem; */
  font-size: 1rem;
  color: #212529;
  text-align: left;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease;
}

.accordion-button[aria-expanded="true"]::before {
  /*font-family: FontAwesome,serif;*/
  /*content: "\f077";*/
  font-family: "Material Icons", serif;
  content: "\e5ce";
  color: #727272;
  font-size: 30px;
  /*width: 1.25rem;*/
  /*height: 1.25rem;*/
  /* background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z' clip-rule='evenodd'/%3e%3c/svg%3e"); */
  /*transform: rotate(360deg);*/
}
.accordion-button::before {
  flex-shrink: 0;
  /*width: 1.25rem;*/
  /*height: 1.25rem;*/
  font-family: "Material Icons", serif;
  content: "\e5cf";
  font-size: 30px;
  /*font-family: FontAwesome,serif;*/
  /*content: "\f078";*/
  color: #727272;
  /* background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z' clip-rule='evenodd'/%3e%3c/svg%3e"); */
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}

/* navbar styling */
label {
  color: #131212;
}

.nav-item a {
  color: white;
  font-family: var(--gotham);
  font-size: 1.1em;
}

/* header */
header {
  height: 60vh;
  /*background: url('../../assets/events/events-bg.png');*/
  width: 100%;
}

.list-group-item :first-child {
  margin-right: 0;
}

.text h1 {
  font-size: 3.125em;
  font-family: var(--gothamBold);
  margin-bottom: 1.5rem;
}

.text p {
  margin-bottom: 1.5rem;
}

/* job fair section*/

.heading h2 {
  font-size: 1.875em;
  font-family: var(--gothamBold);
  margin-bottom: 0;
  color: white;
  text-align: center;
}

.job-fair-text {
  width: 90%;
  /*margin-top: -3rem;*/
  border-radius: 10px;
  padding: 1rem 3rem;
  text-align: left !important;
}

/* upcoming events */

.card {
  color: black;
  margin: 1rem 0;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 599px) and (min-width: 300px) {
  .job-fair-text {
    padding: 0;
  }
}
</style>
